import { ComplianceRuleResultWithMetadata } from '@blk/awt-aladdinwealthserver';
import { CancelToken } from 'axios';
import { AGraphWrappedType, unwrapAGraphResponse, wrapAGraphRequest } from '../../utils/AGraphWrapper';
import { isAGraphEnabled } from './AGraphUtils';
import { awApiWithPkg } from './Base';

export async function postComplianceData(request: { [index: string]: any }, pkg: string, cancelToken?: CancelToken) {
  const path = 'api/v2/deep-dive/compliance';
  const response = await awApiWithPkg.post<AGraphWrappedType<ComplianceRuleResultWithMetadata[], 'items'>>(
    path,
    wrapAGraphRequest(request, 'rollupEntities', isAGraphEnabled()),
    { params: { pkg, cancelToken } }
  );
  return unwrapAGraphResponse(response, 'items');
}
